import React, { useMemo } from 'react'
import { StyleSheet, Text, View } from 'react-native'

// import CancelOrder from './CancelOrder'
import {
  COLORS,
  COMMON_STYLES,
  PARAGRAPH_STYLES,
  SUBHEADING_STYLES,
  TEXT_STYLES,
} from '@dehaat/dds'
import { ORDER_STATUS } from 'app/farmer360/constants/order'
import { OrderResponse } from 'app/farmer360/models/orderDetails'
import ApplicationStepperCircle from '../icons/ApplicationStepperCircle'
import ApplicationStepperTick from '../icons/ApplicationStepperTick'
import ApplicationStepperCross from '../icons/ApplicationStepperCross'
import Stepper, { Step } from './Stepper'
import getDate from 'app/farmer360/utils/helper'
import CancelOrder from './CancelOrder'

interface Props {
  orderId: string
  orderDate: string | null
  deliveryDate: string | null
  status: string
  isPickupFromStore: boolean
  onCancelOrder: (order: OrderResponse) => void
}

const OrderTimeline = ({
  orderId,
  deliveryDate,
  status,
  orderDate,
  isPickupFromStore,
  onCancelOrder,
}: Props) => {
  const getLabel = (text: string) => (
    <Text style={[PARAGRAPH_STYLES.RegularT2, TEXT_STYLES.textNeutral80]}>
      {text}
    </Text>
  )

  const deliveredLabel = useMemo(() => {
    switch (true) {
      case isPickupFromStore:
        return 'Order Successfully Picked up from store'
      case !!deliveryDate:
        return `Delivered on ${getDate(deliveryDate, false, true)}`
      default:
        return 'Delivered'
    }
  }, [isPickupFromStore, deliveryDate])

  const getStep2Data = () => {
    switch (status) {
      case ORDER_STATUS.PreOrder:
      case ORDER_STATUS.Pending:
      case ORDER_STATUS.Success:
        return {
          icon: <ApplicationStepperCircle />,
          label: getLabel('Order confirmed by DeHaat Centre'),
          descViewStyle: styles.descViewStyle,
        }
      case ORDER_STATUS.VendorConfirmed:
      case ORDER_STATUS.ReadyForDelivery:
      case ORDER_STATUS.OutForDelivery:
      case ORDER_STATUS.Delivered:
        return {
          icon: <ApplicationStepperTick />,
          label: getLabel('Order confirmed by DeHaat Centre'),
          descViewStyle: styles.descViewStyle,
        }
      default:
        return {
          icon: <ApplicationStepperCross />,
          label: getLabel(
            deliveryDate
              ? `Cancelled on ${getDate(deliveryDate, false, true)}}`
              : 'Cancelled',
          ),
        }
    }
  }

  const getStep3Data = () => {
    switch (status) {
      case ORDER_STATUS.PreOrder:
      case ORDER_STATUS.Pending:
      case ORDER_STATUS.Success:
      case ORDER_STATUS.VendorConfirmed:
        return {
          icon: <ApplicationStepperCircle />,
          label: getLabel(
            isPickupFromStore
              ? 'Order Successfully Picked up from store'
              : 'Expected delivery soon',
          ),
        }
      case ORDER_STATUS.ReadyForDelivery:
        return {
          icon: <ApplicationStepperCircle />,
          label: getLabel(
            deliveryDate
              ? `Delivery expected on ${getDate(deliveryDate, false, true)}`
              : 'Expected delivery soon',
          ),
        }
      case ORDER_STATUS.OutForDelivery:
        return {
          icon: <ApplicationStepperCircle />,
          label: getLabel('Out for delivery'),
        }
      case ORDER_STATUS.Delivered:
        return {
          icon: <ApplicationStepperTick />,
          label: getLabel(deliveredLabel),
        }
      default:
        return null
    }
  }

  const timelineData: (Step | null)[] = [
    {
      icon: <ApplicationStepperTick />,
      label: getLabel(`Ordered on ${getDate(orderDate, false, true)}`),
      descViewStyle: styles.descViewStyle,
    },
    getStep2Data(),
    getStep3Data(),
  ]

  //   const isCancelOrderVisible =
  //     status === ORDER_STATUS.PreOrder ||
  //     status === ORDER_STATUS.Success ||
  //     status === ORDER_STATUS.Pending ||
  //     status === ORDER_STATUS.VendorConfirmed ||
  //     status === ORDER_STATUS.ReadyForDelivery ||
  //     status === ORDER_STATUS.OutForDelivery

  return (
    <View style={[COMMON_STYLES.p1]}>
      <Text style={[SUBHEADING_STYLES.MEDIUM_S1, TEXT_STYLES.textNeutral80]}>
        {`Order ID ${orderId}`}
      </Text>
      <View style={COMMON_STYLES.mv1}>
        <Stepper steps={timelineData.filter(step => step !== null) as Step[]} />
      </View>
      {/* {isCancelOrderVisible && (
        <CancelOrder
          orderId={orderId}
          isOutForDelivery={status === ORDER_STATUS.OutForDelivery}
          onCancelOrder={onCancelOrder}
        />
      )} */}
    </View>
  )
}

const styles = StyleSheet.create({
  cancelBtn: {
    backgroundColor: COLORS.primary10,
    flex: 0.5,
    marginRight: 8,
  },
  descViewStyle: {
    borderLeftColor: COLORS.neutral20,
    borderLeftWidth: 1,
    marginLeft: 10,
    marginTop: 0,
    paddingBottom: 32,
    paddingLeft: 18,
    paddingTop: 8,
  },
  needHelpBtn: {
    borderColor: COLORS.neutral20,
    borderWidth: 1,
    flex: 0.5,
    marginLeft: 8,
  },
})

export default OrderTimeline
